import { useEffect } from 'react'

/**
 * Custom hook for handling data refresh on component mount
 * Checks if store needs refresh and loads data accordingly
 * @param {Object} store - The store instance with needsRefresh property
 * @param {Array} storedData - Data stored in store (e.g., store.tableData or store.allTableData)
 * @param {Function} restoreState - Function to restore state from store
 * @param {Function} fetchData - Function to fetch fresh data from API
 * @param {Function} setIsLoading - Function to set loading state
 * @param {Function} setIsRefetching - Function to set refetching state
 */
export function useRefreshOnReturn(
  store,
  storedData,
  restoreState,
  fetchData,
  setIsLoading,
  setIsRefetching
) {
  useEffect(() => {
    // Restore state from store if data exists and refresh is not needed
    if (storedData.length > 0 && !store.needsRefresh) {
      restoreState()
      setIsLoading(false)
      setIsRefetching(false)
    } else {
      // Fetch data if not loaded or refresh is needed
      if (store.needsRefresh) {
        store.needsRefresh = false
      }
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

